import { ProfileValueOption, ProfileFields } from '@backrs_ui/grow-ui/src/redux/profile/profile';

import { ResolverFunction } from './resolvers.config';
import { FieldConfig, ProfilePageConfig } from '../types/profile.types';
import { createFieldConfig } from '../utils/fields.helpers';
import {
  mapStandardProfileArrayValues,
  mapStandardProfileSingleValue,
} from '../utils/resolvers.helpers';

export const INTERESTS_FIELD_CONFIGS: Partial<FieldConfig> = {
  hobbiesCreativeInterests: createFieldConfig({
    key: 'hobbiesCreativeInterests',
    type: { variant: 'AUTOCOMPLETE', manualFilterOptions: true },
    chipType: 'pill',
    placeholder: 'Select Creative Interests',
    showSearch: true,
  }),
  hobbiesPassions: createFieldConfig({
    key: 'hobbiesPassions',
    type: { variant: 'AUTOCOMPLETE', manualFilterOptions: true },
    chipType: 'pill',
    placeholder: 'Select Passions',
    showSearch: true,
  }),
  hobbiesFavorites: createFieldConfig({
    key: 'hobbiesFavorites',
    type: { variant: 'AUTOCOMPLETE', manualFilterOptions: true },
    chipType: 'pill',
    placeholder: 'Select your Favorites',
    showSearch: true,
  }),
  demographicsStrengthsFinders: createFieldConfig({
    key: 'demographicsStrengthsFinders',
    type: { variant: 'SINGLE_SELECT' },
    width: 'half',
    textLeadingAdornment: { name: 'StrengthsFinder' },
    placeholder: 'Learner',
  }),
  demographicsMyersBriggs: createFieldConfig({
    key: 'demographicsMyersBriggs',
    type: { variant: 'SINGLE_SELECT' },
    width: 'half',
    textLeadingAdornment: { name: 'Myers Briggs' },
    placeholder: 'ENTJ',
  }),
  demographicsAstrologySigns: createFieldConfig({
    key: 'demographicsAstrologySigns',
    type: { variant: 'SINGLE_SELECT' },
    width: 'half',
    textLeadingAdornment: { name: 'Zodiac' },
    placeholder: 'Aries',
  }),
  demographicsHigh5s: createFieldConfig({
    key: 'demographicsHigh5s',
    type: { variant: 'SINGLE_SELECT' },
    width: 'half',
    textLeadingAdornment: { name: 'High 5' },
    placeholder: 'Believer',
  }),
};

export const INTERESTS_PAGE_CONFIG: ProfilePageConfig = {
  title: 'Interests and hobbies',
  description:
    'This information helps us find scholarships and other opportunities to support you.',
  sections: [
    {
      title: 'Creative Interests',
      keys: ['hobbiesCreativeInterests'],
      description: 'Including arts, craft, performance, etc.',
    },
    {
      title: 'Passions & Causes',
      keys: ['hobbiesPassions'],
      description: 'Issues and organizations that you are active within.',
    },
    {
      title: 'Favorites',
      keys: ['hobbiesFavorites'],
      description: 'Music, books, movies, TV, and games',
    },
    {
      title: 'Assessments and Signs',
      keys: [
        'demographicsMyersBriggs',
        'demographicsAstrologySigns',
        'demographicsHigh5s',
        'demographicsStrengthsFinders',
      ],
    },
  ],
};

export const INTEREST_HELPERS: Partial<
  Record<ProfileFields, ResolverFunction<string | number | ProfileValueOption>>
> = {
  hobbiesCreativeInterests: (profile, options) =>
    mapStandardProfileArrayValues(
      profile.profile.hobbiesCreativeInterests,
      options.hobbiesCreativeInterests,
    ),

  hobbiesPassions: (profile, options) =>
    mapStandardProfileArrayValues(profile.profile.hobbiesPassions, options.hobbiesPassions),

  hobbiesFavorites: (profile, options) =>
    mapStandardProfileArrayValues(profile.profile.hobbiesFavorites, options.hobbiesFavorites),

  demographicsMyersBriggs: (profile, options) =>
    mapStandardProfileSingleValue(
      profile.profile.demographicsMyersBriggs,
      options.demographicsMyersBriggs,
    ),

  demographicsStrengthsFinders: (profile, options) =>
    mapStandardProfileArrayValues(
      profile.profile.demographicsStrengthsFinders,
      options.demographicsStrengthsFinders,
    ),

  demographicsAstrologySigns: (profile, options) =>
    mapStandardProfileSingleValue(
      profile.profile.demographicsAstrologySigns,
      options.demographicsAstrologySigns,
    ),

  demographicsHigh5s: (profile, options) =>
    mapStandardProfileArrayValues(profile.profile.demographicsHigh5s, options.demographicsHigh5s),
};
